'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

var _themeCart = require('@shopify/theme-cart');

var shopifyCart = _interopRequireWildcard(_themeCart);

var _PushBoxItem = require('./PushBoxItem');

var _PushBoxItem2 = _interopRequireDefault(_PushBoxItem);

var _PushBoxCheckbox = require('./PushBoxCheckbox');

var _PushBoxCheckbox2 = _interopRequireDefault(_PushBoxCheckbox);

var _functional = require('../../../utils/functional');

var _utils = require('../../../utils');

var _urlSearchParams = require('@ungap/url-search-params');

var _urlSearchParams2 = _interopRequireDefault(_urlSearchParams);

var _store = require('store2');

var _store2 = _interopRequireDefault(_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var GIFT_WRAPPING_OPTION_NAME = 'Gift Wrapping';
var WITH_GIFT_WRAP_OPTION = 'With gift sleeve';
var WITHOUT_GIFT_WRAP_OPTION = 'Without gift sleeve';

exports.default = {
  name: 'PushBox',

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      boxItems: this.createBoxItems(this.data.boxes.medium.amount),
      currentBox: 'medium',
      currentBoxMax: this.data.boxes.medium.amount,
      hasGiftWrapping: false,
      windowLocation: window.location.href,
      body: document.body || document.documentElement,
      nextRedirect: null
    };
  },
  created: function created() {
    var _this = this;

    document.body.addEventListener('submit', function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var form, formData, id, quantity, properties;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                form = e.target;

                if (!form.matches('.js-AddToCartBox')) {
                  _context.next = 11;
                  break;
                }

                e.preventDefault();

                formData = new FormData(form);
                id = Number(formData.get('id'));
                quantity = Number(formData.get('quantity'));
                properties = (0, _functional.buildProperties)(formData);
                _context.next = 9;
                return shopifyCart.addItem(id, { properties: properties, quantity: quantity });

              case 9:

                // await store.clearAll()

                if (window.drawers.activeDrawerKey !== '') {
                  window.drawers.activeDrawerKey = '';
                }
                window.location.href = _this.nextRedirect;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    document.body.addEventListener('click', function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
        var button, hasMatchingButton, productHandle, firstEmptyIndex, product;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                button = e.target;
                hasMatchingButton = button.matches('.js-BuildABox_Add');

                if (!(hasMatchingButton === false)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:

                _this.body.classList.remove('drw-PushBox-disable');

                e.preventDefault();

                if (window.drawers.activeDrawerKey !== '') {
                  window.drawers.activeDrawerKey = '';
                }

                if (!_this.isFilled) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 10;
                return _this.handleUpgrade();

              case 10:
                productHandle = button.dataset.productHandle;
                firstEmptyIndex = _this.boxItems.findIndex(function (item) {
                  return (0, _keys2.default)(item.product).length === 0;
                });


                _this.$set(_this.boxItems, firstEmptyIndex, (0, _assign2.default)({}, _this.boxItems[firstEmptyIndex], { loading: true }));

                _context2.next = 15;
                return (0, _functional.getProductData)(productHandle);

              case 15:
                product = _context2.sent;


                _this.$set(_this.boxItems, firstEmptyIndex, (0, _assign2.default)({}, _this.boxItems[firstEmptyIndex], { product: product, theme: product.metafields.accentuate.product_theme_colour, loading: false }));

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());

    document.body.addEventListener('click', function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(e) {
        var button, hasMatchingButton, boxType;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                button = e.target;
                hasMatchingButton = button.matches('.js-BuildABox_Size');

                if (!(hasMatchingButton === false)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt('return');

              case 4:

                e.preventDefault();

                boxType = button.dataset.boxType;

                _this.updateBoxAmount(boxType);

                if (button.dataset.buttonPage === 'collection') {
                  scrollToCocktails();
                } else {
                  window.location.href = _this.data.defaultUrl + '?scrollto=cocktails';
                }

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());

    var searchParams = new _urlSearchParams2.default(window.location.search);
    if (searchParams.get('scrollto') === 'cocktails') {
      scrollToCocktails();
    }

    function scrollToCocktails() {
      var scrollTo = (0, _functional.getElement)('.js-BuildABox_Scroll');

      if (scrollTo) {
        (0, _utils.scrollToY)((0, _utils.getOffsetTop)(scrollTo));
      }
    }

    if (_store2.default.has('baoBuildABox')) {
      var sessionData = _store2.default.get('baoBuildABox');

      var currentDate = Date.parse(Date());
      var endDate = Date.parse(sessionData.endDate);

      if (currentDate - endDate > 0) {
        _store2.default.clearAll();

        this.updateBoxAmount(this.data.defaultBox);
      } else {
        this.updateBoxAmount(sessionData.currentBox);

        this.boxItems = sessionData.boxItems;
      }
    } else {
      this.updateBoxAmount(this.data.defaultBox);
    }

    if (searchParams.get('box-size')) {
      var requestedBoxSize = searchParams.get('box-size');

      this.updateBoxAmount(requestedBoxSize);
    }
  },
  mounted: function mounted() {
    if (this.windowLocation.includes('build-a-box') || !this.isEmpty) {
      this.body.classList.remove('drw-PushBox-disable');
    }

    if (this.windowLocation.includes('cart')) {
      this.body.classList.remove('drw-Drawers-pushbox');
    }
  },


  components: {
    PushBoxCheckbox: _PushBoxCheckbox2.default,
    PushBoxItem: _PushBoxItem2.default
  },

  computed: {
    orderedBoxItems: function orderedBoxItems() {
      return this.boxItems.sort(function (a, b) {
        var titleA = a.product.title;
        var titleB = b.product.title;
        if (titleA < titleB) {
          return -1;
        }
        if (titleA > titleB) {
          return 1;
        }
        return 0;
      });
    },
    activeBoxes: function activeBoxes() {
      return (0, _entries2.default)(this.data.boxes).filter(function (boxProduct) {
        return boxProduct[1].product !== '';
      });
    },
    titleString: function titleString() {
      if (this.isFilled) {
        return this.data.translations.fullTitle;
      } else {
        return this.data.translations.title.replace('{{ box_amount }}', this.currentBoxMax);
      }
    },
    counterString: function counterString() {
      var _this2 = this;

      var cardButtons = (0, _functional.getElements)('.js-BuildABox_Add');

      cardButtons.forEach(function (cardButton) {
        var cardButtonText = (0, _functional.getElement)('.btn-Text', { context: cardButton });
        var cardButtonInventory = parseInt(cardButton.dataset.inventoryQuantity);
        var isAdded = false;

        (0, _keys2.default)(_this2.boxItems).forEach(function (item) {
          if (_this2.boxItems[item].product.handle) {
            if (_this2.boxItems[item].product.handle === cardButton.dataset.productHandle) {
              isAdded = true;
            }
          }
        });

        var isInProductSection = Boolean(cardButton.closest('[data-section-type="product"]'));
        var isInProductDrawer = Boolean(cardButton.closest('.drw-Drawer-product'));
        var addToCartText = isInProductSection || isInProductDrawer ? _this2.data.translations.buttonAddCustomText : _this2.data.translations.buttonAddText;

        var addNewText = cardButtonInventory > 0 ? addToCartText : _this2.data.translations.buttonPreOrderText;
        var addAnotherText = cardButtonInventory > 0 ? _this2.data.translations.buttonAddedText : _this2.data.translations.buttonAddedPreOrderText;

        var defaultText = cardButtonText.getAttribute("data-text");

        if (defaultText === null) {
          defaultText = addNewText;
        }

        //cardButtonText.innerHTML = isAdded ? addAnotherText : addNewText
        cardButtonText.innerHTML = isAdded ? addAnotherText : defaultText;
      });

      return this.data.translations.countMessage.replace('{{ current_amount }}', this.filledBoxItems.length).replace('{{ box_amount }}', this.currentBoxMax);
    },
    footerString: function footerString() {
      var upgradeMessage = void 0;

      switch (this.currentBox) {
        case 'small':
          upgradeMessage = this.data.boxes.medium.product === '' ? '' : this.data.translations.upgradeMessageOne.replace('{{ upgrade_amount }}', this.data.boxes.medium.amount).replace('{{ upgrade_price }}', (0, _functional.formatMoney)(this.data.boxes.medium.product.price - this.data.boxes.small.product.price));
          break;

        case 'medium':
          upgradeMessage = this.data.boxes.large.product === '' ? '' : this.data.translations.upgradeMessageTwo.replace('{{ upgrade_amount }}', this.data.boxes.large.amount).replace('{{ upgrade_price }}', (0, _functional.formatMoney)(this.data.boxes.large.product.price - this.data.boxes.medium.product.price));
          break;

        case 'large':
          upgradeMessage = '';
          break;
      }
      return upgradeMessage;
    },
    filledBoxItems: function filledBoxItems() {
      return this.boxItems.filter(function (boxItem) {
        return (0, _keys2.default)(boxItem.product).length > 0;
      });
    },
    isFilled: function isFilled() {
      return this.filledBoxItems.length == this.currentBoxMax;
    },
    isEmpty: function isEmpty() {
      return this.filledBoxItems.length == 0;
    },
    buttonString: function buttonString() {
      return (0, _functional.formatMoney)(this.selectedVariant.price) + ' - ' + this.data.translations.buttonText;
    },
    selectedBox: function selectedBox() {
      var _this3 = this;

      return this.activeBoxes.find(function (_ref4) {
        var _ref5 = (0, _slicedToArray3.default)(_ref4, 1),
            box = _ref5[0];

        return box === _this3.currentBox;
      })[1];
    },
    giftWrappingIsAvailable: function giftWrappingIsAvailable() {
      var options = this.selectedBox.product.options;

      if (!options) {
        return false;
      }

      var giftWrappingOption = options.find(function (option) {
        return option.name === GIFT_WRAPPING_OPTION_NAME;
      });

      if (!giftWrappingOption) {
        return false;
      }

      return giftWrappingOption.values.length > 1;
    },
    giftWrappingOptionIndex: function giftWrappingOptionIndex() {
      return this.selectedBox.product.options.findIndex(function (option) {
        return option.name === GIFT_WRAPPING_OPTION_NAME;
      });
    },
    selectedVariant: function selectedVariant() {
      var _this4 = this;

      if (this.giftWrappingOptionIndex === -1) {
        return this.selectedBox.product.variants[0];
      }

      return this.selectedBox.product.variants.find(function (variant) {
        var value = _this4.hasGiftWrapping ? WITH_GIFT_WRAP_OPTION : WITHOUT_GIFT_WRAP_OPTION;
        return variant.options[_this4.giftWrappingOptionIndex] === value;
      });
    },
    giftWrappingPrice: function giftWrappingPrice() {
      var _this5 = this;

      if (!this.giftWrappingIsAvailable) {
        return 0;
      }

      var product = this.selectedBox.product;
      var giftWrapPrice = product.variants.find(function (variant) {
        return variant.options[_this5.giftWrappingOptionIndex] === WITH_GIFT_WRAP_OPTION;
      }).price;
      var noGiftWrapPrice = product.variants.find(function (variant) {
        return variant.options[_this5.giftWrappingOptionIndex] === WITHOUT_GIFT_WRAP_OPTION;
      }).price;

      return giftWrapPrice - noGiftWrapPrice;
    },
    addGiftWrapString: function addGiftWrapString() {
      return this.data.translations.addGiftWrap.replace(/{{ ?price ?}}/g, (0, _functional.formatMoney)(this.giftWrappingPrice));
    }
  },

  watch: {
    currentBoxMax: function currentBoxMax(val) {
      if (val > this.boxItems.length) {
        this.boxItems = [].concat((0, _toConsumableArray3.default)(this.boxItems.slice(0, val)), (0, _toConsumableArray3.default)(this.createBoxItems(val - this.boxItems.length)));
      } else if (val < this.boxItems.length) {
        this.boxItems = [].concat((0, _toConsumableArray3.default)(this.boxItems.slice(0, val)));
      }
    },
    isFilled: function isFilled(val) {
      if (val) {
        window.drawers.activeDrawerKey = 'pushbox';
      }
    }
  },

  updated: function updated() {
    var endDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);

    _store2.default.set('baoBuildABox', { boxItems: this.boxItems, currentBox: this.currentBox, currentBoxMax: this.currentBoxMax, endDate: endDate });

    var pushBoxDrawer = (0, _functional.getElement)('.js-BuildABox_Drawer');
    var drawerBackdrop = (0, _functional.getElement)('.js-Drawers_Backdrop');
    var animateClass = 'drw-PushBox-animate';

    if (!pushBoxDrawer.matches('.drw-Drawer-active')) {
      pushBoxDrawer.classList.add(animateClass);

      setTimeout(function () {
        pushBoxDrawer.classList.remove(animateClass);
      }, 500);
    }

    var canOpen = true;
    var canCloseBackdropHover = false;

    pushBoxDrawer.addEventListener('mouseenter', function (e) {
      if (canOpen) {
        window.drawers.activeDrawerKey = 'pushbox';
        canCloseBackdropHover = true;
      }
    });

    drawerBackdrop.addEventListener('mouseenter', function (e) {

      if (canCloseBackdropHover) {

        canCloseBackdropHover = false;

        canOpen = false;
        window.drawers.activeDrawerKey = '';

        setTimeout(function () {
          canOpen = true;
        }, 250);
      }
    });
  },


  methods: {
    formatMoney: _functional.formatMoney,

    createBoxItems: function createBoxItems(amount) {
      return (0, _functional.range)(amount).map(function (_, i) {
        return { product: {}, theme: null, loading: false };
      });
    },
    boxTitleString: function boxTitleString(val) {
      return this.data.translations.title.replace('{{ box_amount }}', val);
    },
    handleBoxChange: function handleBoxChange(event) {
      this.updateBoxAmount(event.target.value);
    },
    handleUpgrade: function handleUpgrade() {
      switch (this.currentBox) {
        case 'small':
          this.data.boxes.medium.product != '' && this.updateBoxAmount('medium');
          break;

        case 'medium':
          this.data.boxes.large.product != '' && this.updateBoxAmount('large');
          break;
      }
    },
    removeItem: function removeItem(index, hasContent) {
      if (hasContent) {
        this.boxItems.splice(index, 1);
        this.boxItems = [].concat((0, _toConsumableArray3.default)(this.boxItems.slice(0, this.boxItems.length)), (0, _toConsumableArray3.default)(this.createBoxItems(1)));
      } else {
        window.location.href = this.data.defaultUrl + '?scrollto=cocktails';
      }
    },
    updateBoxAmount: function updateBoxAmount(newBoxType) {
      if (newBoxType !== 'small' && newBoxType !== 'medium' && newBoxType !== 'large') return;

      var findBoxSelectors = (0, _functional.getElements)('.js-BuildABox_SelectorItem');

      findBoxSelectors.forEach(function (findBoxSelector) {
        var currentBoxType = findBoxSelector.dataset.boxItem;
        findBoxSelector.setAttribute('aria-selected', currentBoxType == newBoxType ? true : false);

        var borderClass = 'clc-BuildBoxItem-border';

        if (currentBoxType == 'medium') {
          if (newBoxType == 'small' || newBoxType == 'medium') {
            findBoxSelector.classList.remove(borderClass);
          } else {
            findBoxSelector.classList.add(borderClass);
          }
        } else if (currentBoxType == 'large') {
          if (newBoxType == 'medium' || newBoxType == 'large') {
            findBoxSelector.classList.remove(borderClass);
          } else {
            findBoxSelector.classList.add(borderClass);
          }
        }
      });

      switch (newBoxType) {
        case 'small':
          this.currentBox = 'small';
          this.currentBoxMax = this.data.boxes.small.amount;
          break;

        case 'medium':
          this.currentBox = 'medium';
          this.currentBoxMax = this.data.boxes.medium.amount;
          break;

        case 'large':
          this.currentBox = 'large';
          this.currentBoxMax = this.data.boxes.large.amount;
          break;
      }
    }
  }
};